import {useState} from "react";
import { Client } from "../../types/userManagement";
import {createAutoCheckInConfig, createDefaultAutoCheckInConfig} from "./api";

export function useCreateCheckInConfig(client: Client | undefined, refetchProfiles: () => void) {

    const [error, setError] = useState<string>()
    const [name, setName] = useState("")
    const [submitting, setSubmitting] = useState<boolean>()

    const submit = async () => {
        setError(undefined)
        setSubmitting(true)

        const result = await createAutoCheckInConfig(client, name)

        result.match(
            () => {
                refetchProfiles()
                setName("")
            },
            (err) => setError(err.message)
        )

        setSubmitting(false)
    }

    return {submit, submitting, error, name, setName}

}